// extracted by mini-css-extract-plugin
export default {"history":"history-d85kr","historyMask":"history-mask-mZhiu","historyHeader":"history-header-HoUgl","historyBody":"history-body-d61IP"};